"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.HandlerAPI = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _keys2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var _utils = require("../utils/utils");
var HandlerAPI = /*#__PURE__*/function () {
  function HandlerAPI() {
    (0, _classCallCheck2["default"])(this, HandlerAPI);
  }
  (0, _createClass2["default"])(HandlerAPI, null, [{
    key: "openPdf",
    value: function openPdf() {
      var _context;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      params.attach = 'NO';
      params._UID = _NextApiClient.NextApiClient.getUID();
      params.UGUEST = _NextApiClient.NextApiClient.getGuestUid() || '';
      var newWindow = window.open('', '_blank');
      var formData = document.createElement("form");
      formData.setAttribute("id", "tmpForm");
      formData.setAttribute("method", 'post');
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/xPdfHandler.ashx');
      (0, _forEach["default"])(_context = (0, _keys["default"])(params)).call(_context, function (paramKey) {
        if (!params.hasOwnProperty(paramKey)) return;
        var paramValue = (params[paramKey] + '').replace(/"/g, '|');
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", paramKey);
        input.setAttribute("value", paramValue);
        formData.appendChild(input);
      });
      newWindow.document.body.appendChild(formData);
      var tmpForm = newWindow.document.getElementById('tmpForm');
      tmpForm.submit();
    }
  }, {
    key: "downloadPdfRawData",
    value: function downloadPdfRawData(params) {
      var _context2;
      params._UID = _NextApiClient.NextApiClient.getUID() || '';
      params.UGUEST = _NextApiClient.NextApiClient.getGuestUid() || '';
      var formData = document.createElement("form");
      formData.setAttribute("id", "tmpForm");
      formData.setAttribute("method", 'post');
      formData.setAttribute("target", '_blank');
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/xPdfHandler.ashx');
      (0, _forEach["default"])(_context2 = (0, _keys["default"])(params)).call(_context2, function (paramKey) {
        if (!params.hasOwnProperty(paramKey)) return;
        var paramValue = (params[paramKey] + '').replace(/"/g, '|');
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", paramKey);
        input.setAttribute("value", paramValue);
        formData.appendChild(input);
      });
      document.body.appendChild(formData);
      formData.submit();
      formData.remove();
    }
  }, {
    key: "downloadPdf",
    value: function downloadPdf(fileName, prjId) {
      var versionName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var params = {
        name: 'JORDERVERSPDF',
        attach: fileName,
        version: versionName || fileName,
        id: prjId.toString()
      };
      this.downloadPdfRawData(params);
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(filelist, prjId) {
      var _context3, _context4;
      var progress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      formData.append("_UID", _NextApiClient.NextApiClient.getUID());
      formData.append("projectId", prjId);
      formData.append("uploadmode", '0');
      (0, _map["default"])(_context3 = (0, _from["default"])((0, _keys2["default"])(_context4 = Array(filelist.length)).call(_context4))).call(_context3, function (x) {
        formData.append(filelist[x].name, filelist[x]);
      });
      xhr.open("POST", _NextApiClient.NextApiClient.backSite + "/soapupload.ashx", true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (cb) cb(JSON.parse(xhr.response));
        } else {
          try {
            if (cbErr) cbErr(JSON.parse(xhr.response));
          } catch (err) {
            if (cbErr) cbErr(xhr.response);
          }
        }
      };
      xhr.send(formData);
    }
  }, {
    key: "agoUploadFiles",
    value: function agoUploadFiles(_ref) {
      var _context5, _context6;
      var fileList = _ref.fileList,
        type = _ref.type,
        name = _ref.name,
        catalog = _ref.catalog,
        newname = _ref.newname,
        dim = _ref.dim,
        linklist = _ref.linklist;
      var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      if (!fileList.length && !linklist) return;
      var formData = new FormData();
      (0, _map["default"])(_context5 = (0, _from["default"])((0, _keys2["default"])(_context6 = Array(fileList.length)).call(_context6))).call(_context5, function (x) {
        formData.append(type, fileList[x], fileList[x].name);
      });
      formData.append("_UID", _NextApiClient.NextApiClient.getUID());
      formData.append("Name", name || '');
      formData.append("Catalog", catalog || '');
      formData.append("NewName", newname || '');
      formData.append("Type", type || '');
      formData.append('Dim', dim || '');
      formData.append('linklist', linklist || '');
      var xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', progress);
      xhr.open("POST", _NextApiClient.NextApiClient.backSite + "/upload.ashx", true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (cb) cb(xhr.response);
        } else {
          if (cbErr) cbErr(xhr.response);
        }
      };
      xhr.send(formData);
    }
  }, {
    key: "download",
    value: function download(filename, prjId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var params = {
        projectId: '' + prjId,
        fileName: filename,
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      xhr.open("POST", _NextApiClient.NextApiClient.backSite + '/soapdownload.ashx', true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (cb) cb(xhr.response);
        } else {
          if (cbErr) cbErr(xhr.response);
        }
      };
      xhr.onerror = function () {
        if (cbErr) cbErr(xhr.response);
      };
      xhr.send((0, _utils.fromObjToQueryStr)(params));
    }
  }, {
    key: "downloadFile",
    value: function downloadFile(filename, prjId) {
      var params = {
        projectId: '' + prjId,
        fileName: filename,
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      var formData = document.createElement("form");
      formData.setAttribute("method", "post");
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/soapdownload.ashx');
      formData.setAttribute("target", '_blank');
      var vv = (0, _keys["default"])(params);
      for (var i = 0; i < vv.length; i++) {
        var paramKey = vv[i];
        var paramValue = params[paramKey].replace(/"/g, '|');
        var y = document.createElement("input");
        y.setAttribute("type", "hidden");
        y.setAttribute("name", paramKey);
        y.setAttribute("value", paramValue);
        formData.appendChild(y);
      }
      document.body.appendChild(formData);
      formData.submit();
      formData.remove();
    }
  }, {
    key: "exportJsonScene",
    value: function exportJsonScene(jsonScene) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = document.createElement("form");
      var params = {
        jsonScene: (0, _stringify["default"])(jsonScene),
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      formData.setAttribute("method", "post");
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/exportobjscenedownload.ashx');
      formData.setAttribute("target", '_blank');
      var vv = (0, _keys["default"])(params);
      for (var i = 0; i < vv.length; i++) {
        var paramKey = vv[i];
        var paramValue = params[paramKey];
        var y = document.createElement("input");
        y.setAttribute("type", "hidden");
        y.setAttribute("name", paramKey);
        y.setAttribute("value", paramValue);
        formData.appendChild(y);
      }
      document.body.appendChild(formData);
      formData.submit();
      formData.remove();
    }
  }, {
    key: "exportObjScene",
    value: function exportObjScene(jsonScene) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = document.createElement("form");
      var params = {
        expKey: 'OBJ',
        jsonScene: (0, _stringify["default"])(jsonScene),
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      formData.setAttribute("method", "post");
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/exportobjscenedownload.ashx');
      formData.setAttribute("target", '_blank');
      var vv = (0, _keys["default"])(params);
      for (var i = 0; i < vv.length; i++) {
        var paramKey = vv[i];
        var paramValue = params[paramKey];
        var y = document.createElement("input");
        y.setAttribute("type", "hidden");
        y.setAttribute("name", paramKey);
        y.setAttribute("value", paramValue);
        formData.appendChild(y);
      }
      document.body.appendChild(formData);
      formData.submit();
      formData.remove();
    }
  }, {
    key: "exportIGX",
    value: function exportIGX(jsonScene, jsonData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = document.createElement("form");
      var params = {
        expKey: 'IGX',
        jsonScene: (0, _stringify["default"])(jsonScene),
        jsonData: (0, _stringify["default"])(jsonData),
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      formData.setAttribute("method", "post");
      formData.setAttribute("action", _NextApiClient.NextApiClient.backSite + '/exportobjscenedownload.ashx');
      formData.setAttribute("target", '_blank');
      var vv = (0, _keys["default"])(params);
      for (var i = 0; i < vv.length; i++) {
        var paramKey = vv[i];
        var paramValue = params[paramKey];
        var y = document.createElement("input");
        y.setAttribute("type", "hidden");
        y.setAttribute("name", paramKey);
        y.setAttribute("value", paramValue);
        formData.appendChild(y);
      }
      document.body.appendChild(formData);
      formData.submit();
      formData.remove();
    }
  }, {
    key: "IGXblob",
    value: function IGXblob(jsonScene, jsonData) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      var params = {
        expKey: 'IGX',
        jsonScene: (0, _stringify["default"])(jsonScene),
        jsonData: (0, _stringify["default"])(jsonData),
        _UID: _NextApiClient.NextApiClient.getUID()
      };
      var keys = (0, _keys["default"])(params);
      for (var i = 0; i < keys.length; i++) {
        var paramKey = keys[i];
        var paramValue = params[paramKey];
        formData.append(paramKey, paramValue);
      }
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (cb) cb(xhr.response);
        } else {
          if (cbErr) cbErr(xhr.response);
        }
      };
      xhr.onerror = function () {
        if (cbErr) cbErr(xhr.response);
      };
      xhr.open("POST", "".concat(_NextApiClient.NextApiClient.backSite, "/exportobjscenedownload.ashx"));
      xhr.responseType = 'blob';
      xhr.send(formData);
    }
  }, {
    key: "pdfBlob",
    value: function pdfBlob(params) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      params._UID = _NextApiClient.NextApiClient.getUID();
      var keys = (0, _keys["default"])(params);
      for (var i = 0; i < keys.length; i++) {
        var paramKey = keys[i];
        var paramValue = params[paramKey];
        formData.append(paramKey, paramValue);
      }
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (xhr.response.type !== 'application/pdf') {
            xhr.response.text().then(function (htmlTxt) {
              if (htmlTxt && (0, _indexOf["default"])(htmlTxt).call(htmlTxt, '01-User not connected') > -1) {
                _NextApiClient.NextApiClient.refreshSession().then(function (profile) {
                  params._UID = _NextApiClient.NextApiClient.getUID();
                  HandlerAPI.pdfBlob(params, cb, cbErr);
                })["catch"](cbErr);
              } else {
                if (cbErr) cbErr(xhr.response);
              }
            })["catch"](function (err) {
              if (cbErr) cbErr(xhr.response);
            });
          } else {
            if (cb) cb(xhr.response);
          }
        } else {
          if (cbErr) cbErr(xhr.response);
        }
      };
      xhr.onerror = function () {
        if (cbErr) cbErr(xhr.response);
      };
      xhr.open("POST", "".concat(_NextApiClient.NextApiClient.backSite, "/xPdfHandler.ashx"));
      xhr.responseType = 'blob';
      xhr.send(formData);
    }
  }]);
  return HandlerAPI;
}();
exports.HandlerAPI = HandlerAPI;
//# sourceMappingURL=HandlerAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/HandlerAPI.js
// module id = 1221
// module chunks = 142